import { stripScriptTags } from '@app/js/modules/utils'
// import { Dictionary } from '@app/js/types'
import axios from 'axios'
import { VueConstructor } from 'vue'

export default function install(Vue: VueConstructor): void {
  const components = [
    'CalendarAdmin',
    'VuetifyTest',
    'Menu/Menu',
    'Menu/Cache',
    'Menu/Entornos',
    'Menu/Favs',
    'Menu/Help',
    'Menu/Inicio',
    'Menu/Side',
    'Helpers/Collapsible',
    'Helpers/Logo',
    'Helpers/Observe',
    'Helpers/ColorPicker',
    'Helpers/TableCustom',
    'Helpers/InlineCrudButtons',
    'Helpers/InlineConfirmButton',
    'Helpers/TransitionCustom',
    'Helpers/TransitionGroupCustom',
    'Helpers/Loader',
    'Helpers/AjaxButton',
    'FormSections/Contacts',
    'FormSections/comments',
    'FormSections/calendar',
    'FormSections/MetaData',
    'FormSections/MetaDataImporter',
    'FormSections/PerteneceEntornos',
    'Pages/Auth/Login',
    'Pages/Auth/Logout',
    'Pages/Auth/Restore',
    'Pages/Auth/NewPassword',
    'Pages/Ticket/Uploader',
    'WhatsApp/WhatsappDashboard',
    'WhatsApp/ChatList',
    'WhatsApp/Chat'
  ]

  components.forEach((component) => {
    const componentName = component
      .replace('Helpers/', '')
      .replace('FormSections/', '')
      .replace('Pages/', '')
      .replace('WhatsApp/', '')
      .replace('/', '')
    // console.log(componentName)

    // Vue.component(componentName, () => import(/* webpackChunkName: "[request]" */ `../../vue/components/${component}`))
    Vue.component(
      componentName,
      () => import(`../../vue/components/${component}`)
    )
    Vue.component(
      'SalasForm',
      () => import('@app/js/vue/components/Forms/SalasForm.vue')
    )

    Vue.component('VueAjaxDialog', {
      data: function() {
        return {
          url: '',
          content: ''
        }
      },
      computed: {
        hasContent: function() {
          return this.content !== ''
        }
      },
      methods: {
        close: function() {
          this.content = ''
        },
        setUrl: function(url: string) {
          this.url = url
        },
        setContent: function(content: string) {
          const text = stripScriptTags(content)
          this.content = `${text}`
        },
        post: function(url: string, data?: unknown) {
          this.content = '<div class="text-center"><loader></loader></div>'
          axios.post(url, data).then((response) => {
            this.setContent(response.data)
          })
        }
      },
      render: function(createElement) {
        return createElement(Vue.compile(this.content))
      }
    })
  })
}
